const br = () => <br />;

export const RTF_FUNCTIONS = {
  br,
};
